var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 12,
    r: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1601 8.32003L9.0481 7.28003",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 10.9119L7.48804 9.87195",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.832 15.064C16.832 15.064 15.792 16.104 16.832 17.144C16.832 18.184 17.872 21.296 15.792 21.296C14.752 21.296 13.712 21.296 13.712 21.296",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.448 14.024C33.448 14.024 28.256 10.912 22.024 14.024C22.024 14.024 19.944 16.104 18.912 12.984",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.448 17.144C33.448 17.144 28.256 12.992 20.984 18.184C20.984 19.224 22.024 20.264 20.984 21.296C20.984 22.336 20.984 22.336 22.024 23.376C22.024 23.376 25.136 27.528 16.832 30.648",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.504 22.856L24.104 24.408",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6241 25.968C22.6241 25.968 22.0241 28.56 23.0641 30.64C23.0641 31.68 24.1041 32.72 23.0641 33.752",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.912 34.792C18.912 34.792 22.024 29.6 22.024 27.52",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2161 18.184C27.2161 18.184 30.3281 20.264 26.1761 24.416C27.2161 26.496 29.2881 31.688 22.0241 37.912C20.9841 38.952 18.9121 39.992 15.7921 36.872C12.6721 33.752 3.33608 27.528 8.52808 21.296",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52805 15.064C8.52805 15.064 4.37605 19.216 7.48805 23.368",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.64 19.216C11.64 19.216 10.6 10.912 15.792 8.83198C15.792 8.83198 18.904 7.79198 17.872 2.59998",
    stroke: "#192852",
    strokeMiterlimit: 20
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.064 10.912C23.064 10.912 20.984 6.76001 15.792 8.83201C17.872 7.79201 23.064 8.83201 25.136 3.64001",
    stroke: "#192852",
    strokeMiterlimit: 20
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHealth);
export default __webpack_public_path__ + "static/media/HeartHealth.8c5ca2e8195ef4f029db739d387de94f.svg";
export { ForwardRef as ReactComponent };